(ns manage.content-variant-page.db
  (:require [common.content-function.core :as cfn]
            [common.datascript.init :refer [conn]]
            [common.datascript.util :refer [db->tx-data]]
            [common.db.interceptors :refer [forwarded-event]]
            [common.localstorage :as local-storage]
            [common.url-template :as url-tpl]
            [datascript.core :as d]
            [manage.content-configuration-page.content-configuration.db
             :as content-configuration]
            [manage.content-configuration-page.content-configuration.export
             :as ccp-export]
            [manage.content-configuration-page.content-configuration.import
             :as ccp-import]
            [manage.content-variant-page.content-configuration.db :as cc]
            [manage.content-variant-page.rule.db]
            [manage.content-variant-page.variant-feed.db]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(rf/reg-event-fx :page.content-variant/start
  [(rf/inject-cofx :sub :resource.adset/state)]
  (fn [{:keys [db resource.adset/state]}]
    {:db (assoc-in db [:table.feed/meta :type] :variant)
     :fx [[:dispatch [:resource.schema/get-schemas]]
          [:dispatch [:resource.adset/post-preview-token]]
          (when (= :success state)
            [:dispatch [:page.content-variant/init]])
          [:forward-events [{:register :page.content-variant/adset-init-success
                             :events #{:resource.adset/get-one-success}
                             :dispatch-to [:page.content-variant/init]}]]]}))

(def ^:private forward-events
  [{:register :page.content-variant/get-content-function
    :events #{:resource.content-function-version/activate-version}
    :dispatch-to [:layer.adset/get-content-function]}
   {:register :page.content-variant/set-content-function
    :events #{:resource.content-function/get-one-success
              :resource.feed-importers/get-content-feed-success}
    :dispatch-to [:page.content-variant/init-content-function]}

   {:register :page.content-variant/set-active-version
    :events #{:resource.content-function-version/activate-version}
    :dispatch-to [:page.content-variant/navigate-content-function-version]}
   {:register :page.content-variant/trigger-success
    :events #{:resource.feed-importers/trigger-success}
    :dispatch-to [:page.content-variant/trigger-success]}
   {:register :page.content-variant/get-content-feed-success
    :events #{:resource.feed-importers/get-content-feed-success}
    :dispatch-to [:variant-feed/import-keys "default"]}
   {:register :page.content-variant/get-unique-values-success
    :events #{:resource.content-variants/get-unique-values-success}
    :dispatch-to [:variant-feed/import-unique-values]}])

(rf/reg-event-fx :page.content-variant/init
  [(rf/inject-cofx :sub :resource.adset/current-feed-id)]
  (fn [{:keys [db] :resource.adset/keys [current-feed-id]} _]
    {:db (-> db
             (assoc :page.content-variant/import-status (if current-feed-id :pending :success))
             (assoc :resource.content-variants/reload-after-in-ms 10000))
     :fx [[:posh/transact! [[{:content-configuration/id "default"}]]]

          (when current-feed-id
            [:async-flow {:id :page.content-variant/init-flow
                          :first-dispatch [:page.content-variant/get-feed current-feed-id]
                          :rules [{:when :seen-any-of?
                                   :events [:resource.feed-importers/get-one-failure
                                            :resource.feed-importers/get-content-feed-failure]
                                   :halt? true
                                   :dispatch [:page.content-variant/handle-import-failure]}
                                  {:when :seen-both?
                                   :events [:resource.feed-importers/get-content-feed-success
                                            :resource.feed-importers/get-fields-success]
                                   :halt? true
                                   :dispatch-n [[:table.content-variants/init]
                                                [:resource.content-function/get-content-function-overview]]}
                                  ;; this is needede to handle the case when get-fields not available
                                  {:when :seen-both?
                                   :events [:resource.feed-importers/get-content-feed-success
                                            :resource.feed-importers/get-fields-failure]
                                   :halt? true
                                   :dispatch-n [[:table.content-variants/init]
                                                [:resource.content-function/get-content-function-overview]]}]}])

          [:page.content-variant/register-listener nil]

          [:forward-events (-> [{:unregister :page.content-variant/adset-init-success}]
                               (concat forward-events))]]}))

(rf/reg-event-fx :page.content-variant/destroy
  (fn [{:keys [db]} _]
    {:db (-> db
             (dissoc :page.content-variant       ; TODO: Is that obsolete?
                     :page.content-configuration ; TODO: Remove when entities management is moved to routing
                     :resource.content-function/one
                     :resource.content-variants/unique-values
                     :resource.content-variants/reload-after-in-ms
                     :page.content-variant/import-status
                     :page.content-variant.init-cfn/seen-events))
     :fx [[:page.content-variant/unregister-listener]
          [:posh/transact! [[[:db/retractEntity [:content-configuration/id "default"]]
                             [:db/retractEntity [:variant-feed/id "default"]]]]]
          [:forward-events (map #(hash-map :unregister (:register %))
                                forward-events)]]}))

(rf/reg-event-fx :page.content-variant/navigate-content-function-version
  [forwarded-event
   (rf/inject-cofx :sub [:router/route-data])
   (rf/inject-cofx :sub [:router/path-params])
   (rf/inject-cofx :sub [:router/query-parameters-pre-coercion])
   (rf/inject-cofx :sub [:router/fragment])]
  (fn [{:router/keys [route-data path-params query-parameters-pre-coercion fragment]} [_ version]]
    {:fx [[:router/navigate! [(:name route-data)
                              {:params (assoc path-params :content-function-version version)
                               :query query-parameters-pre-coercion
                               :fragment fragment}]]]}))

(rf/reg-event-fx :page.content-variant/get-feed
  (fn [_ [_ feed-id]]
    {:fx [[:dispatch [:resource.content-optimizing/get-optimizations]]
          [:dispatch [:resource.feed-importers/get-one feed-id]]
          [:dispatch [:resource.feed-importers/get-content-feed feed-id]]
          [:dispatch [:resource.feed-importers/get-fields feed-id]]]}))

(rf/reg-event-fx :page.content-variant/trigger-success
  (fn [{:keys [db]}]
    {:db (assoc-in db [:resource.content-variants/all :state] :pending)
     ;; FIXME: We do this hack, because the content variant loading is async, so we wait for it
     ;; to complete before next steps. Ideally backend should notify the client when it is complete
     ;; but that is a much bigger architectural change
     :fx [[:dispatch-later {:ms 3000 :dispatch [:variant-feed/import-keys "default"]}]
          [:dispatch-later {:ms 3000 :dispatch [:resource.content-function/get-content-function-overview]}]
          [:dispatch-later {:ms 3000 :dispatch [:table.content-variants/refresh]}]]}))

(rf/reg-event-fx :page.content-variant/init-content-function
  [forwarded-event
   (rf/inject-cofx :sub :resource.content-function/value)]
  (fn [{:keys [db]
        ext-content-function :resource.content-function/value} [event-type & _]]
    (let [required-event-types #{:resource.content-function/get-one-success
                                 :resource.feed-importers/get-content-feed-success}
          db (cond-> db
               (contains? required-event-types event-type)
               (update :page.content-variant.init-cfn/seen-events (fnil conj #{}) event-type))
          seen-event-types (:page.content-variant.init-cfn/seen-events db)]
      ;; The effects of this event handler should only happen after we received each required event type at least once.
      (if (not= seen-event-types required-event-types)
        {:db db}
        (let [datoms (concat
                      [[:db/retractEntity [:content-configuration/id "default"]]]
                      (-> (ccp-import/content-configuration "default" ext-content-function)
                          cc/relink-placeholder-expressions db->tx-data))]
          {:db (-> db
                   (assoc :page.content-variant/import-status :pending)
                   (update :page.content-variant dissoc :log-unsaved-transactions))
           :fx [[:posh/transact! [datoms {:on-error [:page.content-variant/handle-import-failure]
                                          :on-success [:page.content-variant/handle-import-success]}]]]})))))

(rf/reg-event-fx :page.content-variant/handle-import-failure
  [(rf/inject-cofx :sub :resource.content-function/value)]
  (fn [{:keys [db]
        payload :resource.content-function/value} [_ error]]
    {:db (assoc db :page.content-variant/import-status :failure)
     :fx [[:sentry/capture [error {:contexts {"Content configuration payload" payload}}]]]}))

(rf/reg-event-fx :page.content-variant/handle-import-success
  (fn [{:keys [db]} _]
    {:db (assoc db :page.content-variant/import-status :success)
     :fx [[:dispatch [:variant-feed/sync-targeting-keys->placeholders [:variant-feed/id "default"]]]
          [:dispatch [:variant-feed/sync-targeting-values->placeholder-expressions [:variant-feed/id "default"]]]
          [:dispatch [:variant-feed/sync-dynamic-targeting-keys->rules [:variant-feed/id "default"]]]
          [:dispatch [:variant-feed/sync-mapped-targeting-values->rules [:variant-feed/id "default"]]]
          [:dispatch [:manage.content-configuration-page.context-source.db/load-schema-output-structures]]
          [:dispatch [:manage.content-configuration-page.context-source.db/load-schema-output-data]]
          [:dispatch [:manage.content-configuration-page.context-source.db/load-param-schemas]]]}))

(rf/reg-sub :page.content-variant/import-status
  (fn [db _]
    (:page.content-variant/import-status db)))

(rf/reg-event-db
  :page.content-variant/load-suppressed-import-warnings-ids
  (fn [db [_ ids]]
    (assoc db :page.content-variant/suppressed-import-warnings ids)))

(rf/reg-fx
  :page.content-variant/store-suppressed-import-warnings
  (fn [import-ids]
    (local-storage/save! :suppressed-import-warnings import-ids)))

(rf/reg-event-fx
  :page.content-variant/save-import-warnings
  [(rf/inject-cofx :localstorage "suppressed-import-warnings")]
  (fn [{:keys [db suppressed-import-warnings-ids]} [_ import-id]]
    (let [import-warnings-ids (conj (or suppressed-import-warnings-ids []) import-id)]
      (-> {:db db}
          (mr/update-db assoc :page.content-variant/suppressed-import-warnings import-warnings-ids)
          (mr/conj-fx [:page.content-variant/store-suppressed-import-warnings import-warnings-ids])))))

(rf/reg-sub
  :page.content-variant/is-import-warnings-suppressed?
  (fn [db [_ import-id]]
    (let [suppressed-warning-ids (:page.content-variant/suppressed-import-warnings db)]
      (and (some? suppressed-warning-ids) (contains? (set suppressed-warning-ids) import-id)))))

(rf/reg-event-fx
  :content-page/download-errors
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [_ url-context] :as cofx} [_ feed-id import-id]]
    (let [uri (url-tpl/render :api/content-build-feed-latest-import-errors-file
                              (assoc url-context
                                     :feed-importer-id feed-id
                                     :import-id import-id))]
      {:http {:method :get
              :uri uri
              :headers {"Authorization" (:resource.user/token cofx)}
              :response-format :binary+filename
              :on-success [:content-page/download-errors-success import-id]
              :on-failure [:content-page/download-errors-failure import-id]}})))

(rf/reg-event-fx
  :content-page/download-errors-success
  (fn [_ [event _import-id response]]
    {:fx [[:binary/download response]
          [:dispatch [:toaster-bus/add {:id :content-page/download-errors-success
                                        :type :success
                                        :message "The errors file was downloaded successfully"
                                        :event event}]]]}))

(rf/reg-event-fx
  :content-page/download-errors-failure
  (fn [_ [event reject response]]
    {:fx [[:dispatch [:toaster-bus/add {:id :content-page/download-errors-failure
                                        :type :error
                                        :message "Something went wrong while downloading the errors file."
                                        :event event
                                        :response response}]]
          [:promise/reject reject]]}))

(rf/reg-event-fx :page.content-variant/export
  [(rf/inject-cofx :ds)
   (rf/inject-cofx :sub :context)
   (rf/inject-cofx :sub [:resource.content-function/one])
   (rf/inject-cofx :sub [:page.content-configuration/last-exported-cfn])
   (rf/inject-cofx :sub [:resource.content-function-version/active-version])]
  (fn [{:keys [ds]
        {:keys [adset-id]} :context
        {last-received-cfn :value stored-adset-id :adset-id} :resource.content-function/one
        last-exported-cfn :page.content-configuration/last-exported-cfn
        {active-version-name :name} :resource.content-function-version/active-version} _]
    (let [cfn (ccp-export/ext-content-function ds [:content-configuration/id "default"] (:meta last-received-cfn))]
      (when (and (not= active-version-name "published")
                 (content-configuration/persist? stored-adset-id adset-id last-received-cfn last-exported-cfn cfn))
        {:fx [[:dispatch [:page.content-configuration/set-last-exported-cfn cfn]]
              [:dispatch [:manage.content-configuration-page.view.save/start-save]]
              [:dispatch [:resource.content-function/put-one
                          (cfn/->payload cfn)
                          {:stage active-version-name
                           :on-success [:page.content-variant/handle-export-success]
                           :on-failure [:page.content-variant/handle-export-failure]}]]]}))))

(rf/reg-event-fx :page.content-variant/handle-export-failure
  (fn [_ [event response]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name "Content variant"
                       :type :error
                       :message "Could not save content variant configuration"
                       :event event
                       :response response}]]]}))

(rf/reg-event-fx :page.content-variant/handle-export-success
  (fn [_ _]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name "Content variant"
                       :type :success
                       :message "Content variant configuration has been saved"}]]]}))

(rf/reg-fx :page.content-variant/register-listener
  (fn [_]
    (d/listen! conn :persist-changes
               (fn [{:keys [tx-data tempids]}]
                 (rf/dispatch [:manage.content-configuration-page.view.save/log-unsaved-transaction tx-data (:db/current-tx tempids)])
                 (rf/dispatch [:page.content-variant/export])
                 (rf/dispatch [:manage.content-configuration-page.context-source.db/parameter-change-update-schema-output-structure tx-data])))))

(rf/reg-fx :page.content-variant/unregister-listener
  (fn [_]
    (d/unlisten! conn :persist-changes)))
